var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { StorageService } from '../storage.service';
import { AppConstant } from '../app.constant';
import { ToastrService } from '../toastr.service';
import { AppUtil } from '../app.service';
import { CustomuserService } from '../user/customuser.service';
import { CustomcognitoServiceUtil } from './customcognito.service';
import { CognitoUtil } from '../common/cognito.service';
var CustomauthService = /** @class */ (function () {
    function CustomauthService(http, storageService, appUtil, customuserService, customcognitoServiceUtil, toastr, cognitoUtil) {
        this.http = http;
        this.storageService = storageService;
        this.appUtil = appUtil;
        this.customuserService = customuserService;
        this.customcognitoServiceUtil = customcognitoServiceUtil;
        this.toastr = toastr;
        this.cognitoUtil = cognitoUtil;
    }
    /**
     * set permissions
     */
    CustomauthService.prototype.formHeader = function () {
        var _this = this;
        var that = this;
        return new Observable(function (observer) {
            var header = new HttpHeaders();
            if (that.token) {
                header = header.append('Authorization', that.token);
                observer.next(header);
            }
            else {
                _this.cognitoUtil.getIdToken({
                    callback: function () {
                    },
                    callbackWithParam: function (param) {
                        if (!param) {
                            // console.log('user not logged in');
                            _this.customuserService.logoutCustom();
                        }
                        else {
                            // console.log('got  ID token ', param);
                            that.token = param;
                            header = header.append('Authorization', that.token);
                            observer.next(header);
                        }
                    }
                });
            }
        });
    };
    CustomauthService.prototype.setUserPermission = function () {
        var _this = this;
        var that = this;
        // console.log('user permission called');
        return new Observable(function (observer) {
            _this.appUtil.spinnerInit();
            return _this.formHeader().subscribe(function (header) {
                var options = { headers: header };
                //      console.log(JSON.stringify(options));
                var query = '?data=' + encodeURI(JSON.stringify({ 'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone }));
                _this.http.get(AppConstant.AWS_API_ENDPOINT + '/userpermission' + query, options)
                    .subscribe(function (response) {
                    //        console.log('response  ', response);
                    _this.savePermission(response);
                    observer.next(response);
                }, function (err) {
                    //      console.log('http error++', err);
                    if (err.status === 401 || err.status === 403) {
                        //      console.log('user token invalid login again');
                        _this.customuserService.logoutCustom();
                    }
                    observer.error(err);
                });
            }, function (err) {
                // console.log('authorization failed ' + err);
                observer.error();
            });
        });
    };
    CustomauthService.prototype.hasAccess = function (action) {
        // console.log('action', action);
        var role = (this.permission) ? this.permission.role : this.storageService.get('role');
        var privilage = (this.permission) ? this.permission.permission : this.storageService.getPermissions();
        // console.log('privilage', privilage);
        if (Number(role) === AppConstant.Role.ADMIN) {
            return true;
        }
        else if (Number(role) === AppConstant.Role.Custom && this.storageService.get('allowAccessAsAdmin') && this.storageService.get('allowAccessAsAdmin') === 'true') {
            return true;
        }
        else {
            var access = privilage.find(function (d) { return d.action === action; });
            // alert(JSON.stringify(access) + 'acesssssss');
            // console.log('access', access);
            //  var a = access ? Boolean('true') : '' && true;
            //  alert(JSON.stringify(a) + 'aaaaa')
            var a = access ? access : '' && true;
            // console.log('a',a);
            return a.grant;
        }
    };
    CustomauthService.prototype.savePermission = function (data) {
        // console.log(data);
        this.phone = data.phone.split(' ');
        this.countryCode = this.phone[0];
        this.appUtil.spinnerDone();
        this.permission = data;
        // console.log('custom user permission details', JSON.stringify(this.permission));
        this.storageService.setRole(data.role);
        this.storageService.set('user', data.userId);
        this.storageService.set('profileName', data.userName);
        this.storageService.set('countryCode', this.countryCode);
        if (data.role === AppConstant.Role.Custom) {
            this.storageService.set('team', data.team);
            this.storageService.set('isPartner', data.isPartner);
            this.storageService.set('allowAccessAsAdmin', data.allowAccessAsAdmin);
            this.storageService.setPermissions(data.permission);
        }
    };
    CustomauthService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpClient, StorageService, AppUtil,
            CustomuserService, CustomcognitoServiceUtil,
            ToastrService, CognitoUtil])
    ], CustomauthService);
    return CustomauthService;
}());
export { CustomauthService };



//////////////////
// WEBPACK FOOTER
// ./src/app/customcommon/customauth.service.ts
// module id = ./src/app/customcommon/customauth.service.ts
// module chunks = main